import React from "react";
import { useCorpSettingStore } from "@/stores";
import styles from "./ShippingInfo.module.less";
import { utils } from "@/utils";
import { t } from '@/utils/i18n'
const { kilobitFormat } = utils;

interface ShippingInfoProps {
  deliveryType: number
}

// 运费说明
const ShippingInfo: React.FC<ShippingInfoProps> = (props) => {
  const { deliveryType } = props;
  const { corpSetting } = useCorpSettingStore();
  const { currencySymbol, cod } = corpSetting;
  function createServiceFeeDom() {
    if (!cod.serviceFeeRatioMin && !cod.serviceFeeRatioMax) {
      return { __html: '0' }
    }

    const serviceFee = cod.serviceFeeRatioMin === cod.serviceFeeRatioMax ? cod.serviceFeeRatioMin + '%' : `${cod.serviceFeeRatioMin}%~${cod.serviceFeeRatioMax}%`;
    return { __html: `${serviceFee}${t('服务费')} <br /> + <br />${t('运输费')}` };
  }

  return (
    <div className={styles["card-wrap"]}>
      <h2 className={styles["title"]}>{t('运费信息')}</h2>
      <table className={styles["table-wrap"]}>
        <thead>
          <tr>
            <th>{t('邮寄方式')}</th>
            <th>{t('可用的')}</th>
            <th>{t('成本')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>COD</td>
            <td>
              {currencySymbol}
              {kilobitFormat(cod.codMin)} <br />~<br /> {currencySymbol}
              {kilobitFormat(cod.codMax)}
            </td>
            <td dangerouslySetInnerHTML={createServiceFeeDom()}></td>
          </tr>
          <tr>
            <td>{t('自提')}</td>
            <td>{t('任何数量')}</td>
            <td>{ deliveryType === 1 ? '0' : t('运输费')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default ShippingInfo;
